import i18ntext from 'i18next'
import { initReactI18next } from 'react-i18next'
import Request from './request'
import {messages} from './config.json'

i18ntext
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    lng: 'en',
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: Object.keys(messages).reduce((acc, lang) => {
      acc[lang] = {
        translation: messages[lang]
      }
      return acc
    }, {})
  })


Request.call('getDashboardConfig')
.then((data) => {
  Object.keys(data.messages).forEach((lang) => {
    i18ntext.addResourceBundle(lang, 'translation', data.messages[lang], true, true)
  })
})

export default i18ntext